import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3655 4.81914L4.81923 21.3654",
			stroke: "#583F35",
			strokeWidth: 2.4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3656 21.3655L4.81926 4.81923",
			stroke: "#583F35",
			strokeWidth: 2.4,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMenuClose);
export { ForwardRef as ReactComponent };
